import script from "./Setting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Setting.vue?vue&type=script&lang=ts&setup=true"

import "./Setting.vue?vue&type=style&index=0&id=6c8811d3&lang=scss"

const __exports__ = script;

export default __exports__